<template>
  <div id="app" :class="['route--' + $route.name]">
    <Loader :value="isLoading" :delay="0" theme="default" :class="{ 'app--loading': isLoading }">
      <template v-if="!isLoading" #default>
        <Layout>
          <router-view />
        </Layout>

        <Upsell />

        <TaskModal />
        <PricingModal />
        <Notification />
        <Modal :show="Boolean(customModal)" @close="onCustomModalClose" v-bind="(customModal || {}).modalProps || {}">
          <component
            v-if="customModal"
            :is="customModal.component"
            @close="customModal = null"
            v-bind="customModal.props"
          />
        </Modal>
      </template>

      <template #loader="{ content }">
        <div>
          <img src="/api/client/logo-light" alt="Kvass" width="200px" />
        </div>
        <div class="elder-loader__loading-message">{{ content.messages.loading }}</div>
        <FontAwesomeIcon class="elder-loader__loading-icon" v-bind="content.icon" spin />
      </template>
    </Loader>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { PrefixObjectKeys } from '@/utils'

import Layout from '@/layouts/Default'
import Upsell from '@/components/Upsell'
import Notification from '@/components/Notification'

import TaskModal from '@/components/Task/Modal'
import { ModalComponent as Modal } from 'vue-elder-modal'
import PricingModal from '@/components/Pricing/Modal'

export default {
  metaInfo() {
    return {
      title: this.$t('loggingIn') + '...',
      titleTemplate: ['%s', this.vendor.name].filter(Boolean).join(' | '),
      bodyAttrs: {
        ...PrefixObjectKeys('route-param-', this.$route.params),
        ...PrefixObjectKeys('route-data-', this.customBodyAttrs),
        'route-name': this.$route.name,
        'route-path': this.$route.path,
        'data-kvass-account': window.location.hostname,
      },
    }
  },
  data() {
    return {
      customModal: null,
    }
  },
  computed: {
    ...mapState(['vendor', 'user', 'intercomAppId', 'initialLoad']),
    isLoading() {
      return this.$path('loading', this.$auth)
    },
    customBodyAttrs() {
      if (!this.$route.meta) return {}
      return Object.fromEntries(
        Object.entries(this.$route.meta.bodyAttrs || {}).map(([k, p]) => [k, this.$path(p, this.$store.state)]),
      )
    },
  },
  methods: {
    onCustomModalClose() {
      if (!this.customModal || !this.customModal.onClose) return
      this.customModal.onClose()
      this.customModal = null
    },
  },
  mounted() {
    document.body.classList.remove('initializing')

    this.$bus.on('modal:show', modal => (this.customModal = modal))
  },
  components: {
    Layout,
    Upsell,
    TaskModal,
    PricingModal,
    Notification,
    Modal,
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  & > .elder-loader {
    transition: background-color 200ms ease;

    & > .elder-loader__element {
      .elder-loader__loading-message {
        display: none;
      }

      .elder-loader__element-content-inner {
        display: flex;
        gap: 1.5rem;
        flex-direction: column;
        align-items: center;

        svg {
          margin: 0;
          color: rgba(white, 0.2);
        }
      }
    }
  }

  .app--loading {
    background-color: hsl(var(--primary-h), var(--primary-s), 7%);
    z-index: 9;

    & > *:not(.elder-loader__element) {
      display: none;
    }
  }
}
</style>
